import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { FcAbout } from 'react-icons/fc';
import { GoChecklist } from 'react-icons/go';
import { GiPathDistance } from "react-icons/gi";
import { MdLeaderboard, MdOutlineGolfCourse } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';
import { Container, JoinButton } from './styles';

import ImageBg from '../../assets/perseghian/banner2.jpg';
import ImageBg2 from '../../assets/perseghian/banner11.jpg';
import ImageBg3 from '../../assets/perseghian/banner12.jpg';
import ImageBg4 from '../../assets/perseghian/banner16.jpg';
import ImageBg5 from '../../assets/perseghian/banner17.jpg';
import ImageBg6 from '../../assets/perseghian/banner19.jpg';
import ImageBg7 from '../../assets/perseghian/banner20.jpg';
import CustomFooter from '../../components/Footer/customFooter';

const imageArray = [
  {
    img: ImageBg,
    idx: 1,
    position: 'bottom'
  },
  {
    img: ImageBg2,
    idx: 2,
    position: 'middle'
  },
  {
    img: ImageBg3,
    idx: 3,
    position: 'middle'
  },
  {
    img: ImageBg4,
    idx: 4,
    position: 'middle'
  },
  {
    img: ImageBg5,
    idx: 5,
    position: 'middle'
  },
  {
    img: ImageBg6,
    idx: 6,
    position: 'bottom'
  },
  {
    img: ImageBg7,
    idx: 7,
    position: 'middle'
  },
]

export default function Home() {
  const history = useHistory()
  const {goToTop} = useApp()

  document.title = '2024 The Parseghian Classic'

  const [bgImage, setBgImage] = React.useState(ImageBg)
  const [bgPosition, setBgPosition] = React.useState('bottom')
  const [counter, setCounter] = React.useState(20); 
  const [imageIdx, setImageIdx] = React.useState(0)

  useEffect(() => {
    goToTop()

    const timer = setTimeout(() => {
      setCounter(counter - 1)
      if(imageIdx === imageArray.length - 1) {
        setImageIdx(0);
      } else {
        setImageIdx(imageIdx + 1);
      }

      setBgImage(imageArray[imageIdx].img)
      setBgPosition(imageArray[imageIdx].position)
    }, 15000);
    return () => clearTimeout(timer);
  }, [counter, goToTop, imageIdx])

  return (
    <>
      <Container 
        bgImage={bgImage}
        bgPosition={bgPosition}
        as={motion.div} 
        variants={fadeIn} 
        initial="hidden" 
        animate="show" 
        className="bg-overlay" >
        <div className="container pb-5" style={{minHeight: '50vh'}}>
          <div className="row rowsafari container">
            <div className="col-lg-12">
                <h1 className="section-margin-bottom text-white">The 2024 Parseghian Classic</h1>
                <p className="intro-content text-white">
                  Welcome to the <i>2024 Parseghian Classic</i>. 
                </p>
                <div className="row mt-2">
                  <JoinButton onClick={() => history.push('/leaderboard')}>
                    <MdLeaderboard size={24}/>
                    Leaderboard
                  </JoinButton>
                </div>
                <div className="row mt-2">
                  <JoinButton onClick={() => history.push('/scoreboards')}>
                    <GoChecklist size={24}/>
                    Scorecards
                  </JoinButton>
                </div>
                <div className="row mt-2">
                  <JoinButton onClick={() => history.push('/holedashboard')}>
                    <MdOutlineGolfCourse size={22}/>
                    Hole by Hole
                  </JoinButton>
                </div>
                <div className="row mt-2">
                  <JoinButton onClick={() => history.push('/geography')}>
                    <FaMapMarkedAlt size={20}/>
                    Geography
                  </JoinButton>
                </div>
                <div className="row mt-2">
                  <JoinButton onClick={() => history.push('/bonus-games')}>
                    <GiPathDistance size={20}/>
                    Bonus Games
                  </JoinButton>
                </div>
                <div className="row mt-2" >
                  <JoinButton onClick={() => history.push('/about')}>
                    <FcAbout size={24}/>
                    About IPC
                  </JoinButton>
                </div>
            </div>
          </div>
        </div>
      </Container>
      <CustomFooter />
    </>
  )
}